import { useSyncExternalStore } from 'react';

function parseHashParams<T = Record<string, string>>(hash: string): T {
  const cleanHash = hash.replace('#', '');

  if (!cleanHash) {
    return {} as T;
  }

  const params = new URLSearchParams(cleanHash);
  return Object.fromEntries(params) as T;
}

let cachedParams: unknown = {};
let cachedHash = '';

function getSnapshot<T = Record<string, string>>(): T {
  const currentHash = window.location.hash;

  if (currentHash !== cachedHash) {
    cachedHash = currentHash;
    cachedParams = parseHashParams<T>(currentHash);
  }

  return cachedParams as T;
}

function subscribe(callback: () => void) {
  window.addEventListener('hashchange', callback);
  window.addEventListener('popstate', callback);

  return () => {
    window.removeEventListener('hashchange', callback);
    window.removeEventListener('popstate', callback);
  };
}

export function useHashParams<T = Record<string, string>>(): T {
  return useSyncExternalStore(subscribe, getSnapshot<T>);
}
